<template>
  <div class="d-flex flex-column gap-4">
    <v-alert v-if="error" type="error" class="mb-0">
      {{ error }}
    </v-alert>
    <div>
      <v-card elevation="0" :loading="loading">
        <div class="pa-1">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busque por nome ou plataforma"
            single-line
            outlined
            hide-details
            clearable
            dense
          />
        </div>
      </v-card>
      <p v-if="!loading" class="text-caption mb-0 text-center">
        {{ organizations.length }} organizações
      </p>

      <v-chip-group
        v-if="platforms.length"
        v-model="platformFilter"
        active-class="primary--text"
        mandatory
      >
        <v-chip :value="null">Todas</v-chip>
        <v-chip
          v-for="platform in platforms"
          :value="platform.id"
          :key="platform.id"
        >
          {{ platform.name }}
        </v-chip>
      </v-chip-group>
    </div>

    <v-row dense class="mx-0">
      <v-col
        v-for="organization in filteredSort"
        :key="organization.id"
        cols="12"
        md="6"
        lg="4"
      >
        <organization-card :organization="organization" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ORGANIZATION from "@/services/admin/organizations";
import OrganizationCard from "@/components/admin/organization/OrganizationCard.vue";
export default {
  name: "Organizations",
  metaInfo: {
    title: "Organizações",
  },
  components: { OrganizationCard },
  data: () => {
    return {
      loading: false,
      error: null,
      search: "",
      organizations: [],
      platformFilter: null,
    };
  },
  methods: {
    async getOrganizations() {
      try {
        this.loading = true;
        this.error = null;

        const { organizations } = await ORGANIZATION.getOrganizations();
        this.organizations = organizations;
      } catch (error) {
        this.error = error.message || "Erro ao buscar organizações";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    platforms() {
      const d = this.organizations.reduce((acc, organization) => {
        if (!organization.active || !organization.Platform.active) return acc;
        if (!acc[organization.Platform.id]) {
          acc[organization.Platform.id] = organization.Platform;
        }
        return acc;
      }, {});

      return Object.values(d).sort((a, b) => a.name.localeCompare(b.name));
    },
    filteredSort() {
      const organizations = this.organizations;
      if (!this.search && !this.platformFilter) return organizations;

      return organizations.filter((organization) => {
        const plataformaCorrespondente =
          !this.platformFilter ||
          organization.Platform.id === this.platformFilter;
        const nomeOrganizacaoContemBusca = organization.name
          .toLowerCase()
          .includes(this.search.toLowerCase());
        const nomePlataformaContemBusca = organization.Platform.name
          .toLowerCase()
          .includes(this.search.toLowerCase());

        return (
          plataformaCorrespondente &&
          (nomeOrganizacaoContemBusca || nomePlataformaContemBusca)
        );
      });
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.organizations = [];
      this.getOrganizations();
    },
  },
  mounted() {
    this.getOrganizations();
    if (this.$route.query.platform) {
      this.platformFilter = this.$route.query.platform;
    }
  },
};
</script>

<style></style>
